'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = exports.updateRoute = exports.addRoutes = exports.addRoute = exports.setRoute = exports.delRoute = exports.getRouteInfo = exports.routeId = exports.defaultState = exports.ROUTE_PREFIX = undefined;

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _reducers;

exports.requireNew = requireNew;

var _capeLodash = require('cape-lodash');

var _capeRedux = require('cape-redux');

var _utils = require('./utils');

var _actions = require('./actions');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROUTE_PREFIX = exports.ROUTE_PREFIX = 'route';

var defaultState = exports.defaultState = _defineProperty({
  trailingSlash: false
}, ROUTE_PREFIX, {});

var routeId = exports.routeId = function routeId(id) {
  return [ROUTE_PREFIX, id];
};

var getRouteInfo = exports.getRouteInfo = (0, _flow3.default)(routeId, _get3.default);

function requireNew(state, payload) {
  if (getRouteInfo(payload.id)(state)) {
    throw new Error('Already have a route with the id of "' + payload.id + '".');
  }

  return true;
}

var delRoute = exports.delRoute = function delRoute(state, payload) {
  return (0, _capeLodash.delAt)(routeId(payload), state);
};

var setRoute = exports.setRoute = function setRoute(state, payload) {
  return (0, _capeLodash.setIn)(routeId(payload.id), state, payload);
};

var addRoute = exports.addRoute = function addRoute(state, payload) {
  return requireNew(state, payload) && setRoute(state, (0, _utils.getInfo)(state, payload));
};

var addRoutes = exports.addRoutes = function addRoutes(state, payload) {
  return (0, _reduce3.default)(payload, addRoute, state);
};

var updateRoute = exports.updateRoute = function updateRoute(state, payload) {
  return setRoute(state, (0, _capeLodash.merge)(getRouteInfo(payload.id)(state), (0, _utils.getInfo)(state, payload)));
};

var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.ADD_ROUTE, addRoute), _defineProperty(_reducers, _actions.ADD_ROUTES, addRoutes), _defineProperty(_reducers, _actions.DEL_ROUTE, delRoute), _defineProperty(_reducers, _actions.UPDATE_ROUTE, updateRoute), _reducers);
exports.default = (0, _capeRedux.createReducer)(reducers, defaultState);